var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.985 13.5V8.531h.001c0-3.047-1.641-5.625-4.5-6.328V1.5c0-.844-.656-1.5-1.5-1.5s-1.5.656-1.5 1.5v.703c-2.859.703-4.5 3.234-4.5 6.328V13.5L1.97 15.516v.984h16.031v-.984L15.985 13.5Zm-8.016 4.03c0 1.078.89 1.969 2.016 1.969 1.096 0 1.968-.805 1.968-1.969H7.969Zm9.985-9.515c-.141-2.672-1.5-4.969-3.516-6.422L15.844.187c2.391 1.828 3.984 4.641 4.125 7.828h-2.015Zm-15.938 0c.141-2.672 1.5-4.969 3.563-6.422L4.125.187C1.734 2.015.141 4.827 0 8.015h2.016Z",
    fill: "currentColor"
  })));
};
export default SvgNotification;